export default {
    yAxis: [{
        title: {
            text: ''
        },
        categories: "",
        labels: {
            formatter: function () {
                var label = this.axis.defaultLabelFormatter.call(this);
                return label/1000 + ' Mil.';
            },
            format: '{value}',
            style: {
                color: '#b0b6c3',
                fontSize: '15px'
            }
        },
        opposite: false
    }],
    series: [{
        name: function(){
            if(document.documentElement.lang == 'cz'){
                return "Vlastní kapitál"
            }
            else{
                return "Equity"
            }
            
        }(),
        data: [45474, 32492, 49695, 62636, 333165, 385600, 274859, 1015000, 2330778, 2348363, 2393295, 2537365, 3521673, 3792981],
        marker: {
            enabled: false
        },
    }],
}

//504610


// WEBPACK FOOTER //
// ./data/charts/kapital.js